import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { Users, FileText, Mail, BarChart3, User, TrendingUp, Image as ImageIcon, Wallet, Shield, Package, Sparkles, FileCheck2 } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const DEPRECATED_TABS = ['declaration-dommage'];

export function useCooperDashboard() {
  const { user, logout, getAuthHeader } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [demandes, setDemandes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cooperData, setCooperData] = useState(null);

  const tabFromUrl = searchParams.get('tab');
  const initialTab = tabFromUrl && !DEPRECATED_TABS.includes(tabFromUrl) ? tabFromUrl : 'statistiques';
  const [activeTab, setActiveTab] = useState(initialTab);

  useEffect(() => {
    if (tabFromUrl && !DEPRECATED_TABS.includes(tabFromUrl) && tabFromUrl !== activeTab) {
      setActiveTab(tabFromUrl);
    }
  }, [tabFromUrl]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [demandesRes, cooperRes] = await Promise.all([
        axios.get(`${API}/demandes-publiques`, { headers: getAuthHeader() }).catch(() => ({ data: [] })),
        axios.get(`${API}/coopers/me`, { headers: getAuthHeader() }).catch(() => ({ data: null }))
      ]);
      setDemandes(demandesRes.data || []);
      setCooperData(cooperRes.data);
    } catch {
      // Ne pas afficher de toast pour éviter les messages répétés lors des changements d'onglet
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    logout();
    window.location.href = '/';
  };

  const sidebarTabs = [
    { value: 'wallet-credits', label: 'Mes Crédits ESS', icon: <Wallet className="h-5 w-5 text-emerald-600" />, highlight: true },
    { value: 'kpi-dashboard', label: '📈 Mes KPIs', icon: <TrendingUp className="h-5 w-5 text-green-600" /> },
    { value: 'statistiques', label: 'Statistiques & CA', icon: <BarChart3 className="h-5 w-5" /> },
    { value: 'membres', label: 'Mes Membres adhérents', icon: <Users className="h-5 w-5" /> },
    { value: 'souscriptions-liste', label: 'Toutes Souscriptions', icon: <FileText className="h-5 w-5" /> },
    { value: 'preuves-virement', label: 'Preuves de virement', icon: <FileCheck2 className="h-5 w-5 text-emerald-600" /> },
    { value: 'propositions-signees', label: '✍️ Propositions signées', icon: <FileText className="h-5 w-5 text-purple-600" />, highlight: true },
    { value: 'suivi-signatures', label: 'Suivi des signatures', icon: <FileText className="h-5 w-5 text-purple-600" />, highlight: true },
    { value: 'suivi-rcds', label: 'Suivi RCDS', icon: <Shield className="h-5 w-5 text-indigo-600" />, highlight: true },
    { value: 'registre-maitres-ouvrage', label: "Registre Maîtres d'ouvrage", icon: <FileText className="h-5 w-5 text-[#0a3d62]" /> },
    { value: 'assistant-ia-devis', label: 'Assistant IA Devis', icon: <Sparkles className="h-5 w-5 text-violet-600" />, highlight: true },
    { value: 'conventions', label: 'Mes Conventions', icon: <FileText className="h-5 w-5" /> },
    { value: 'videos', label: 'Photos/Vidéos', icon: <ImageIcon className="h-5 w-5 text-purple-600" /> },
    { value: 'partages-recus', label: 'Partages reçus', icon: <Package className="h-5 w-5 text-indigo-600" /> },
    { value: 'messagerie', label: 'Messagerie', icon: <Mail className="h-5 w-5" /> },
    { value: 'profil', label: 'Mon Profil', icon: <User className="h-5 w-5" /> },
  ];

  return {
    user, getAuthHeader, navigate,
    demandes, loading, cooperData, setCooperData,
    activeTab, setActiveTab, fetchData, handleLogout, sidebarTabs,
  };
}
